import { extend } from 'flarum/common/extend';

/**
 * fof/rich-text (newly added) has its own composer toolbar, entirely
 * separate from flarum-markdown's own markdownToolbarItems() - see
 * removeMarkdownImageButton.js, which only covers the plain-markdown
 * fallback and does nothing once rich-text's own toolbar is what's
 * actually shown. Removes the same "insert image via URL" affordance
 * again here (dead once inserted - see removeMarkdownImageButton.js's own
 * docblock for why: the server no longer renders that syntax as an image
 * at all), plus both spoiler-family buttons (requested directly): the
 * inline mark in the main bar ('spoiler_inline', French tooltip
 * "Divulgâcher") and the block wrap in the "+" overflow dropdown
 * ('spoiler_block', French tooltip "Masquer" - confirmed against
 * vendor/flarum-lang/french/locale/fof-rich-text.yml, matching "le
 * spoiler et masquer" exactly).
 *
 * String extend() target (ext:fof/rich-text/...), not a direct
 * `import TiptapMenu from 'ext:...'` - champis-forum doesn't composer-
 * depend on fof/rich-text (it's meant to work whether or not that
 * extension is even installed, same spirit as its own "optional-
 * dependencies": ["champis/events"] entry), so there's no guarantee its
 * bundle has already run and registered TiptapMenu by the time
 * champis-forum's own bundle evaluates a direct import - confirmed the
 * hard way: that form threw "Cannot read properties of undefined
 * (reading 'prototype')" at boot. The string form defers via flarum.reg's
 * own onLoad callback instead, so this only ever fires once (if) rich-
 * text's bundle actually registers the target, regardless of script order
 * or whether the extension is enabled at all.
 */
export default function removeRichTextToolbarButtons() {
  extend('ext:fof/rich-text/common/components/TiptapMenu', 'items', function (items) {
    items.remove('image');
    items.remove('spoiler_inline');
  });
  extend('ext:fof/rich-text/common/components/TiptapMenu', 'hiddenItems', function (items) {
    items.remove('spoiler_block');
  });
}